/* @flow weak */
import * as React from 'react';
import Link from 'components/Link';
import CurrentUser from 'auth/CurrentUser';
import Container from 'components/Container';
import JoinGroupModal from './JoinGroupModal';
import TitleHeader from 'components/TitleHeader';
import GroupCreateModal from './GroupCreateModal';
import ModalTrigger from 'components/ModalTrigger';
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';

import './styles/BootstrapHandler.scss';

type Props = {
  router: *,
};

class BootstrapHandler extends React.Component<Props> {
  handleGroupCreated = group => {
    this.props.router.push(getRedirectLocationAfterGroupCreation(group));
  };

  handleGroupJoined = group => {
    this.props.router.push(getRedirectLocationAfterGroupJoin(group));
  };

  renderSubtext = () => {
    const groupCreateModal = (
      <GroupCreateModal onCreate={this.handleGroupCreated} onRequestHide={() => {}} />
    );
    const joinGroupModal = (
      <JoinGroupModal onJoin={this.handleGroupJoined} onRequestHide={() => {}} />
    );
    const user = CurrentUser.getUser();

    if (!user.canCreateGroups()) {
      return (
        <div>
          <ModalTrigger modal={joinGroupModal}>
            <span>
              <Link>Join a class</Link> to start using Remind.
            </span>
          </ModalTrigger>
        </div>
      );
    }

    if (user.isTeacher()) {
      return (
        <div>
          <ModalTrigger modal={groupCreateModal}>
            <Link>Create a class</Link>
          </ModalTrigger>{' '}
          or{' '}
          <ModalTrigger modal={joinGroupModal}>
            <span>
              <Link>join a class</Link> to start using Remind.
            </span>
          </ModalTrigger>
        </div>
      );
    }

    return (
      <div>
        <ModalTrigger modal={groupCreateModal}>
          <Link>Create a class</Link>
        </ModalTrigger>{' '}
        to stay connected with your clubs, teams, organizations, and more!
      </div>
    );
  };

  render() {
    return (
      <div className="BootstrapHandler">
        <Container size="small">
          <TitleHeader
            size="large"
            glyph="remind-icon"
            title="Get started!"
            subtext={this.renderSubtext()}
          />
        </Container>
      </div>
    );
  }
}

export default BootstrapHandler;
